import { useAuth } from "./useGoogleAuth";


export const googlePlugin = {
    install: (app, options) => {
        const { userState, initAuth } = useAuth();
        if (!userState.isAuthenticated) {
            initAuth();
        }
    }
};